import { create } from 'zustand';
import { createBannerSlice } from './banner/store/index.slice';
import { BannerSlice } from './banner/store/index.type';
import { createEmojiPickerSlice } from './emoji/emojiPicker/store/index.slice';
import { EmojiPickerSlice } from './emoji/emojiPicker/store/index.types';
import {
  createGifEmbedAssetSlice,
  createGifPickerSlice,
} from './gif/store/index.slice';
import { GifEmbedAssetSlice, GifPickerSlice } from './gif/store/index.types';
import { createImagePreviewSlice } from './imagePreview/store/index.slice';
import { ImagePreviewSlice } from './imagePreview/store/index.types';
import { createMentionsSlice } from './mentions/store/index.slice';
import { MentionsSlice } from './mentions/store/index.types';
import { createSecondaryMenuSlice } from './secondaryMenu/store/index.slice';
import { SecondaryMenuSlice } from './secondaryMenu/store/index.types';
import { createSidePanelSlice } from './sidePanel/store/index.slice';
import { SidePanelSlice } from './sidePanel/store/index.types';

export type UIStore = EmojiPickerSlice &
  SidePanelSlice &
  BannerSlice &
  MentionsSlice &
  GifPickerSlice &
  GifEmbedAssetSlice &
  ImagePreviewSlice &
  SecondaryMenuSlice;

export const useUIStore = create<UIStore>((...a) => ({
  ...createEmojiPickerSlice(...a),
  ...createSidePanelSlice(...a),
  ...createBannerSlice(...a),
  ...createMentionsSlice(...a),
  ...createGifPickerSlice(...a),
  ...createGifEmbedAssetSlice(...a),
  ...createImagePreviewSlice(...a),
  ...createSecondaryMenuSlice(...a),
}));
